import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { VisruptLogo } from '../assets/logo';

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <nav className="bg-slate-900 text-white sticky top-0 z-50">
      <div className="max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <VisruptLogo className="h-8 w-8 sm:h-9 sm:w-9" />
            <span className="font-bold text-2xl sm:text-3xl">ViSRUPT</span>
          </Link>
          
          <div className="hidden md:flex items-center space-x-6 lg:space-x-10">
            <Link to="/" className="text-base lg:text-lg hover:text-blue-400 transition">Home</Link>
            <Link to="/divisions" className="text-base lg:text-lg hover:text-blue-400 transition">Divisions</Link>
            <Link to="/services" className="text-base lg:text-lg hover:text-blue-400 transition">Services</Link>
            <Link to="/pricing" className="text-base lg:text-lg hover:text-blue-400 transition">Pricing</Link>
            <Link to="/faq" className="text-base lg:text-lg hover:text-blue-400 transition">FAQ</Link>
            <Link to="/careers" className="text-base lg:text-lg hover:text-blue-400 transition">Careers</Link>
            <Link to="/about" className="text-base lg:text-lg hover:text-blue-400 transition">About Us</Link>
            <Link to="/contact" className="bg-blue-500 hover:bg-blue-600 px-6 py-3 rounded-lg transition text-base lg:text-lg">Contact Us</Link>
          </div>

          <div className="md:hidden">
            <button 
              onClick={() => setIsOpen(!isOpen)}
              className="p-2.5 rounded-lg hover:bg-slate-800 transition"
            >
              {isOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
            </button>
          </div>
        </div>

        {isOpen && (
          <div className="md:hidden fixed inset-x-0 top-20 bg-slate-900 border-t border-slate-800 shadow-lg">
            <div className="flex flex-col space-y-2 px-6 py-4">
              <Link 
                to="/" 
                className="px-4 py-3 hover:bg-slate-800 rounded-lg text-lg"
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/divisions" 
                className="px-4 py-3 hover:bg-slate-800 rounded-lg text-lg"
                onClick={() => setIsOpen(false)}
              >
                Divisions
              </Link>
              <Link 
                to="/services" 
                className="px-4 py-3 hover:bg-slate-800 rounded-lg text-lg"
                onClick={() => setIsOpen(false)}
              >
                Services
              </Link>
              <Link 
                to="/pricing" 
                className="px-4 py-3 hover:bg-slate-800 rounded-lg text-lg"
                onClick={() => setIsOpen(false)}
              >
                Pricing
              </Link>
              <Link 
                to="/faq" 
                className="px-4 py-3 hover:bg-slate-800 rounded-lg text-lg"
                onClick={() => setIsOpen(false)}
              >
                FAQ
              </Link>
              <Link 
                to="/careers" 
                className="px-4 py-3 hover:bg-slate-800 rounded-lg text-lg"
                onClick={() => setIsOpen(false)}
              >
                Careers
              </Link>
              <Link 
                to="/about" 
                className="px-4 py-3 hover:bg-slate-800 rounded-lg text-lg"
                onClick={() => setIsOpen(false)}
              >
                About Us
              </Link>
              <Link 
                to="/contact" 
                className="bg-blue-500 hover:bg-blue-600 px-4 py-3 rounded-lg text-lg text-center"
                onClick={() => setIsOpen(false)}
              >
                Contact Us
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;